const filterForm = document.getElementById('blog-filters');
const searchResults = document.querySelector('#blogResults');
const categoryFilter = document.querySelectorAll('.search-filter-categories');
const blogResultsContainer = document.querySelector('#blogResultsContainer');
const blogNoResults = document.querySelector('#blogNoResults');
const blogPaging = document.querySelector('#blogPaging');

if (filterForm) {
    filterForm.addEventListener('submit', function (e) {
        e.preventDefault();
        e.stopPropagation();
        const currentPage = filterForm.querySelector('input[name="page"]').value;

        const qs = new URLSearchParams(new FormData(e.target)).toString();
        fetch(`/assets/components/bcha/getArticles.php?${qs}`, {
            method: 'GET',
        })
            .then(function (response) {
                if (response.ok) {
                    return response.json();
                }
                return Promise.reject(response);
            })
            .then(function (data) {
                // console.log(data);
                searchResults.innerHTML = data.results.trim();

                if (data.countAll == 0) {
                    blogNoResults.classList.remove('hidden');
                    blogResultsContainer.classList.add('hidden');
                    blogPaging.classList.add('hidden');
                } else {
                    blogResultsContainer.classList.remove('hidden');
                    blogNoResults.classList.add('hidden');
                    blogPaging.classList.remove('hidden');
                }

                // work out pagination
                const { page, totalPages } = data;
                const pages = [];
                if(totalPages >= 1) {
                    for (let _p = 1; _p <= totalPages; _p++) {
                        pages.push(`<li> <a href="" data-page="${_p}" class="paging ${data.page == _p ? 'active' : ''}">${_p}</a></li>`);
                    }
                    filterForm.querySelector('#blogPaging ul').innerHTML = pages.join('');
                }
            })
            .catch(function (error) {
                console.warn(error);
            });
    });
}

categoryFilter.forEach((item) => {
    item.addEventListener('change', (event) => {
        filterForm.dispatchEvent(new Event('submit', { cancelable: true}));
    });
});

if (filterForm) {
    filterForm.dispatchEvent(new Event('submit', { cancelable: true}));

    document.addEventListener('click',function(e){
        if(e.target && e.target.className.indexOf('paging') !== -1) {
            e.preventDefault();
            e.stopPropagation();
            const { page } = e.target.dataset;
            const pageItem = filterForm.querySelector('input[name="page"]');
            if(pageItem) pageItem.value = page;
            filterForm.dispatchEvent(new Event('submit', { cancelable: true }));
            document.getElementById('blogResultsContainer').scrollIntoView();
        }
    });

}